import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';

import Loader from '../../../common/component/Loader/Loader';

import {Button, Modal, Row, Col} from 'react-bootstrap';

import * as IconFi from 'react-icons/fi';
import OffcanvasExpertCompanion from "../../offcanvas/ExpertCompanion/ExpertCompanion";

const ModalExpertCompanion = props => {
    const navigate = useNavigate()

    // -----------------------------------------------------------------------------------------------------------------

    const data = props.data

    // ----------------------------------------------------------------------------------------------------- show & hide

    const handlePopstate = () => {

        // چک شد که offcanvasExpertCompanion باعث navigate(-1) شده یا خیر
        if ((!window.location.hash.includes('#modalExpertCompanion') && !window.location.hash.includes('#offcanvasExpertCompanion'))) {
            if (document.querySelectorAll('.modal').length < 2)
                window.removeEventListener('popstate', handlePopstate)

            props.onHide()
        }

    }

    const onShowHandler = () => {

        document.getElementById('modalExpertCompanion').style.paddingRight = document.querySelector('body').style.paddingRight

        navigate('#modalExpertCompanion')
        window.addEventListener('popstate',  handlePopstate);

    }

    const onHideHandler = () => {

        navigate(-1)

    }

    // -------------------------------------------------------------------------------------- expert companion offcanvas

    const [offcanvasData, setOffcanvasData] = useState(null);
    const [offcanvasExpertCompanionShow, setOffcanvasExpertCompanionShow] = useState(false);

    const offcanvasExpertCompanionShowHandler = companion => {

        setOffcanvasData(() => {
            return companion
        })

        setOffcanvasExpertCompanionShow(true);

    }

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <>
            <Modal id="modalExpertCompanion" aria-labelledby="expertCompanionTitle" {...props} backdrop={false} fullscreen onHide={onHideHandler} onShow={onShowHandler} className="ltr bg-body" dialogClassName={`rtl${data ? ' h-auto' : ''}`} contentClassName="container-lg px-0">
                <Modal.Header className="position-sticky top-0">
                    <Button variant="link" onClick={onHideHandler} className="my-md-1 text-reset border-0 btn-icon"><IconFi.FiArrowRight size={24} className="sw-1 m-2"/></Button>
                    <Modal.Title className="me-4 pe-3 flex-grow-1 text-center fs-5 text-truncate">رزرو همراه متخصص</Modal.Title>
                </Modal.Header>
                {
                    data ? (
                        <Modal.Body className="overflow-visible pt-0 pb-4 pb-xl-5">
                            <Row className="gx-2 gy-3">
                                {
                                    data.length && (
                                        data.map(item => {
                                            return (
                                                <Col xs={6} sm={3} lg={2} onClick={() => offcanvasExpertCompanionShowHandler(item)} key={item.id}>
                                                    <div role="button">
                                                        <figure className="bg-elevate-1 ratio ratio-1x1 mb-2 filter-warm">
                                                            {
                                                                item.img && <><span className="filter-level"/><img src={item.img} alt="" className="h-100 w-100 object-fit-cover"/></>
                                                            }
                                                        </figure>
                                                        <div className="mw-100 text-truncate">{item.title}</div>
                                                    </div>
                                                </Col>
                                            )
                                        })
                                    )
                                }
                            </Row>
                        </Modal.Body>
                    ) : (
                        <Modal.Body className="d-flex justify-content-center align-items-center">
                            <Loader text="در حال دریافت اطلاعات"/>
                        </Modal.Body>
                    )
                }
            </Modal>
            <OffcanvasExpertCompanion show={offcanvasExpertCompanionShow} onHide={() => setOffcanvasExpertCompanionShow(false)} data={offcanvasData}/>
        </>
    )
}

export default ModalExpertCompanion;